<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="clickDetail">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="createData">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-button
            id="searchData"
            class="btn grey btn-import-form m__r--5"
            @click="popoverSearchShow = true">
            <i class="fa fa-search fa-lg"/> Search
          </b-button>
          <j-import-file-oos
            v-if="openImport && !readOnly"
            :href-sample="require('@/assets/file/FORMAT_IMPORT_SISWA.zip')"
            class="import-style"
            @import-data="importData"/>
          <div class="cc-btn">
            <b-button
              v-if="is_error"
              class="btn outline red"
              @click="$refs.editSiswa.show()">
              <i class="fa fa-close"/>
              Open Error Data
            </b-button>
            <!-- <b-button
              v-else-if="data_import && !is_error"
              class="btn green outline"
              @click="uploadData">
              Import Data
            </b-button> -->
          </div>
        </b-form>
      </div>
    </v-server-table>
    <!-- <v-client-table
      v-show="load_first"
      :data="data_table"
      :columns="columns"
      :options="options"
      class="jTable"
      @row-click="clickDetail">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="createData">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-button
            id="searchData"
            class="btn grey btn-import-form"
            @click="popoverSearchShow = true">
            <i class="fa fa-search fa-lg"/> Search
          </b-button>
        </b-form>
      </div>
    </v-client-table> -->
    <jLoadingTable v-if="!load_first"/>

    <b-popover
      ref="searchModal"
      :show.sync="popoverSearchShow"
      container="form-search-popover"
      target="searchData"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>

    <j-progress-screen
      ref="ImportFile"
      :data-kirim="data_import"
      :url-api="url"
      :headers="headers"
      @finish="reloadPage"/>

    <b-modal
      ref="editSiswa"
      class="mod-form"
      centered>
      <h3 class="float-to-center c--red">
        Error Data
      </h3>
      <v-client-table
        v-if="error_data[0]"
        :data="error_data"
        :columns="columns"
        :options="options"
        class="jTable">

        <div
          slot="ERROR"
          slot-scope="props">
          <div
            v-for="(err, index) in props.row.ERROR"
            :key="index">
            {{ err }}
          </div>
        </div>

      </v-client-table>
      <download-excel
        :data="error_data"
        class="float-to-right m__t--30"
        name="data-error.xls">
        <b-button class="btn green">
          Export Error
        </b-button>
      </download-excel>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import Vue from 'vue';
import { mapActions } from 'vuex';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKesiswaan from '@/services/jApiKesiswaan';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jProgressScreen from '@/components/progress-screen/jProgressScreen';

export default {
  components: {
    jLoadingTable,
    jProgressScreen,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Data Siswa',
        // opt_title: 'Requester',
      },
      popoverSearchShow: false,
      filter_data: '',
      select_type: 'nama_siswa',
      options_search: [
        {
          text: 'NIS',
          value: 'nis',
        },
        {
          text: 'Nama SIswa',
          value: 'nama_siswa',
        },
      ],
      load_first: false,
      length_table: '',
      data_table: [],
      selected_rows: [],
      columns: ['id', 'nis', 'nama_siswa', 'nisn', 'tanggal_diterima'],
      options: {
        headings: {
          id: 'ID',
          nis: 'NIS',
          nisn: 'NISN',
          nama_siswa: 'NAMA',
          tanggal_diterima: 'TANGGAL DITERIMA',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              // column: data.orderBy ? data.orderBy : '',
              // ascending: !!data.ascending,
              query: data.query ? data.query : '',
              query_type: data.query_type ? data.query_type : '',
            },
          };
        },
        requestFunction(data) {
          const getList = jApiKesiswaan.getListSiswa(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      openImport: true,
      data_import: null,
      list_error: [],
      error_data: [],
      is_error: false,

      // client-table
      // list_siswa: [],
      // columns: ['nis', 'name'],
      // options: {
      //   headings: {
      //     nis: 'NIS',
      //     name: 'NAMA SISWA',
      //   },
      //   sortIcon: { base: 'fa', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' },
      //   sortable: [],
      //   filterable: false,
      // },
    };
  },
  computed: {
    url() {
      const getEnv = 'siswa/create';
      return getEnv;
    },
    headers() {
      const token = Vue.ls.get('Token');
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      return headers;
    },
  },
  watch: {
    filter_data(val) {
      if (val === '') {
        this.$refs.tableServer.setFilter('');
      }
    },
  },
  created() {
    // const params = {
    //   pagination: {
    //     query: '',
    //     query_type: 'nama_siswa',
    //   },
    // };
    // this.getListSiswa(params).then((res) => {
    //   this.list_siswa = res.data.data;
    //   this.data_table = this.list_siswa;
    //   this.load_first = true;
    // });
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKesiswaan', ['getListSiswa']),

    loading(val) {
      const a = val;
      a.pagination.query_type = this.select_type;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      this.$refs.tableServer.setFilter(val);
      // if (val) {
      //   this.data_table = this.list_siswa.filter(f => String(f[this.select_type]).toLowerCase().includes(val.toLowerCase()));
      // } else {
      //   this.data_table = this.list_siswa;
      // }
      this.popoverSearchShow = false;
    },

    clickDetail({ row }) {
      this.$router.replace(`/data-siswa/detail/${row.nis}`);
    },

    createData() {
      this.$router.replace('/data-siswa/create');
    },

    importData(val) {
      const keys = Object.keys(val[0]);
      if (keys[0] !== 'NIS' ||
          keys[1] !== 'NISN' ||
          keys[2] !== 'NAMA_SISWA' ||
          keys[3] !== 'ALAMAT_SISWA' ||
          keys[4] !== 'TEMPAT_LAHIR' ||
          keys[5] !== 'TANGGAL_LAHIR' ||
          keys[6] !== 'JENIS_KELAMIN' ||
          keys[7] !== 'AGAMA' ||
          keys[8] !== 'WARGA_NEGARA' ||
          keys[9] !== 'ANAK_KE' ||
          keys[10] !== 'JML_SDR_KANDUNG' ||
          keys[11] !== 'JML_SDR_TIRI' ||
          keys[12] !== 'JML_SDR_ANGKAT' ||
          keys[13] !== 'YATIM_PIATU' ||
          keys[14] !== 'BAHASA_HARIAN' ||
          keys[15] !== 'NAMA_AYAH' ||
          keys[16] !== 'NAMA_IBU' ||
          keys[17] !== 'ALAMAT_ORTU' ||
          keys[18] !== 'NOTLP_ORTU' ||
          keys[19] !== 'NAMA_WALI' ||
          keys[20] !== 'ALAMAT_WALI' ||
          keys[21] !== 'NOTLP_WALI' ||
          keys[22] !== 'PEKERJAAN_AYAH' ||
          keys[23] !== 'PEKERJAAN_IBU' ||
          keys[24] !== 'PEKERJAAN_WALI' ||
          keys[25] !== 'TAHUN_MASUK' ||
          keys[26] !== 'SEKOLAH_ASAL' ||
          keys[27] !== 'TANGGAL_DITERIMA') {
        this.toggleProblem('Please use header format correctly');
      }
      this.is_error = false;
      this.list_error = [];
      this.error_data = val;
      const fileData = val;
      const genData = [];
      fileData.forEach((e, index) => {
        const ccData = this.convertData(e, index);
        if (ccData !== false) {
          genData.push(ccData);
        }
      });
      this.data_import = genData;

      setTimeout(() => {
        if (this.data_import && !this.is_error) {
          this.$refs.ImportFile.toggleIsVisible();
        }
      }, 1000);
    },

    convertData(val, indexData) {
      this.list_error[indexData] = [];
      this.error_data[indexData].ERROR = [];
      const packing = {
        nis: val.NIS,
        nisn: val.NISN,
        nama_siswa: val.NAMA_SISWA,
        alamat_siswa: val.ALAMAT_SISWA,
        foto_siswa: null,
        tempat_lahir: val.TEMPAT_LAHIR,
        tanggal_lahir: val.TANGGAL_LAHIR,
        jenis_kelamin: val.JENIS_KELAMIN,
        agama: val.AGAMA,
        warga_negara: val.WARGA_NEGARA,
        anak_ke: val.ANAK_KE,
        jml_sdr_kandung: val.JML_SDR_KANDUNG,
        jml_sdr_tiri: val.JML_SDR_TIRI,
        jml_sdr_angkat: val.JML_SDR_ANGKAT,
        yatim_piatu: val.YATIM_PIATU,
        bahasa_harian: val.BAHASA_HARIAN,
        status_siswa: null,
        ket_status: '',
        post_date: null,
        nama_ayah: val.NAMA_AYAH,
        nama_ibu: val.NAMA_IBU,
        alamat_ortu: val.ALAMAT_ORTU,
        notlp_ortu: val.NOTLP_ORTU,
        nama_wali: val.NAMA_WALI,
        alamat_wali: val.ALAMAT_WALI,
        notlp_wali: val.NOTLP_WALI,
        pekerjaan_ayah: val.PEKERJAAN_AYAH,
        pekerjaan_ibu: val.PEKERJAAN_IBU,
        pekerjaan_wali: val.PEKERJAAN_WALI,
        tahunmasuk: val.TAHUN_MASUK,
        sekolah_asal: val.SEKOLAH_ASAL,
        diterima_dikelas: '',
        tanggal_diterima: val.TANGGAL_DITERIMA,
        nik_kitas: '',
        berkebutuhan_khusus: '',
        rt: '',
        rw: '',
        dusun: '',
        desa_kelurahan: '',
        kecamatan: '',
        kodepos: '',
        tempat_tinggal: null,
        moda_transportasi: null,
        penerima_kps: '',
        no_kps: '',
        layak_pip: '',
        alasan_layak_pip: null,
        no_kip: '',
        nama_tertera_di_kip: '',
        no_kks: '',
        bank: '',
        no_akta_lahir: '',
        no_rekening_bank: '',
        rekening_atas_nama: '',
        npsn_sekolah_asal: '',
        nik_ayah: '',
        tahun_lahir_ayah: '',
        pendidikan_ayah: '',
        penghasilan_ayah: '',
        kebutuhan_khusus_ayah: '',
        nik_ibu: '',
        tahun_lahir_ibu: '',
        pendidikan_ibu: '',
        penghasilan_ibu: '',
        kebutuhan_khusus_ibu: '',
        nik_wali: '',
        tahun_lahir_wali: '',
        pendidikan_wali: '',
        penghasilan_wali: '',
        no_telepon_rumah: '',
        no_telepon: '',
        email: '',
        berat_badan: '',
        tinggi_badan: '',
        jarak_ke_sekolah: '',
        jarak_dalam_km: '',
        waktu_jam: '',
        waktu_menit: '',
        jumlah_saudara_kandung: '',
      };
      if (!val.NIS) {
        this.is_error = true;
        this.list_error[indexData].push('NIS tidak boleh kosong');
        this.error_data[indexData].ERROR.push('NIS tidak boleh kosong');
      }
      if (!val.NISN) {
        this.is_error = true;
        this.list_error[indexData].push('NISN tidak boleh kosong');
        this.error_data[indexData].ERROR.push('NISN tidak boleh kosong');
      }
      if (!val.NAMA_SISWA) {
        this.is_error = true;
        this.list_error[indexData].push('Nama Siswa tidak boleh kosong');
        this.error_data[indexData].ERROR.push('Nama Siswa tidak boleh kosong');
      }
      if (!val.ALAMAT_SISWA) {
        this.is_error = true;
        this.list_error[indexData].push('Alamat Siswa tidak boleh kosong');
        this.error_data[indexData].ERROR.push('Alamat Siswa tidak boleh kosong');
      }
      return packing;
    },

    uploadData() {
      this.$refs.ImportFile.toggleIsVisible();
    },

    reloadPage() {
      this.$refs.tableServer.getData();
      this.openImport = false;
      this.data_import = null;
      this.list_error = [];
      this.error_data = [];
      this.is_error = false;
      setTimeout(() => {
        this.openImport = true;
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kesiswaan/siswa/jSiswaList.vue